import 'jquery';
import "select2";
import {standardAjaxGet} from "stdjs/standard-ajax";
import Translator from './translate-service';

export function autocompleteOptions(selectOptions, data) {

    // if(typeof selectOptions.placeholder == "undefined"){
    //     selectOptions.placeholder = null;
    // }
    
    if(typeof selectOptions.maximumSelectionLength == "undefined"){
        selectOptions.maximumSelectionLength = 0;
    }

    var options = {
        // placeholder: selectOptions.placeholder,
        allowClear: selectOptions.allowClear,
        maximumSelectionLength: selectOptions.maximumSelectionLength,
        openOnEnter: false,
        language: {
            loadingMore:function() { return Translator.tr("Loading more results..."); },
            searching: function() { return  Translator.tr("Searching..."); },
            inputTooShort: function(info){
                let charsLeft = info.minimum - info.input.length;
                if (data != null && data.type != null){
                    switch (data.type) {
                        case "*CUSTOMER":
                            return Translator.tr("Please enter {{NUM}} or more characters. You can search by customer code, matchcode, or name.", charsLeft);
                        case "*CARRIER":
                            return Translator.tr("Please enter {{NUM}} or more characters. You can search by carrier code, matchcode, or name.", charsLeft);
                        case "*SENDRECEIVER":
                            return Translator.tr("Please enter {{NUM}} or more characters. You can search by sender/receiver code, matchcode, or name.", charsLeft);
                        default:
                            break;
                    }
                }
                return Translator.tr("Please enter {{NUM}} or more characters.", charsLeft);
            },

            errorLoading: function () {
                return Translator.tr('The results could not be loaded.');
            },
            inputTooLong: function (args) {
                var overChars = args.input.length - args.maximum;

                return Translator.tr('Please delete {{NUM}} character.', overChars);
            },
            maximumSelected: function (args) {
                return Translator.tr('You can only select {{NUM}} item.', args.maximum);
            },
            noResults: function () {
                return Translator.tr('No results found.');
            },
            removeAllItems: function () {
                return Translator.tr('Remove all items.');
            }
        },
        disabled: selectOptions.disabled,
        dropdownAutoWidth: true,
        tags: selectOptions.tags
    };

    if (data != null && data.type != null && typeof select2Language !== "undefined" && select2Language != null && select2Language[data.type] != null){
        // options.language.inputTooShort = function(info){
        //     return select2Language[data.type];
        // }
    }

    if (selectOptions.useAjax){

        options.minimumInputLength = 3;
        options.ajax = {
            delay: 500,
            transport: function (params, success, failure) {
                var data = selectOptions.ajaxData;
                data.search = params.data.term;

                var successCallback = function(data){
                    success({results: data.results});
                };
                return standardAjaxGet(selectOptions.url, data, successCallback, null, false);
            }
        };
    }
    
    return options;
};

export function setupSelect2(selector, url, data, disabled, emptyShowAll, extraOptions = {}){

    if(typeof url == "undefined"){
        url = null;
    }
    if(typeof data == "undefined"){
        data = null;
    }
    if(typeof disabled == "undefined"){
        disabled = false;
    }
    if(typeof emptyShowAll == "undefined"){
        emptyShowAll = false;
    }
    
    extraOptions = $.extend( 
        {},
        { 
            onSelect: function( e ){},
            onClear: function( e ) {}
        },
        extraOptions
    );

    $(selector).each(function(index, element){

        var selectOptions = {
            allowClear: $(element).attr("data-allow-clear") == "1" ? true : false,
            // placeholder: $(element).attr("data-placeholder"),
            useAjax: $(element).attr("data-type-ahead") == "1" ? true : false,
            maximumSelectionLength: $(element).attr("data-max-selects"),
            url: url,
            ajaxData: data,
            disabled: disabled, 
            tags: $(element).attr( "data-tags" ) == "1"  ?  true  :  false          
        };
        
        $(element).select2(autocompleteOptions(selectOptions, data));

        $(element).on("select2:selecting", function(e){
            if(e.params.args.data.id == "*ALL"){
                $(element).val(null).trigger("change");
                $(element).val("*ALL");
                $(element).trigger("change");
            } else {
                if($(element).val() == null || $(element).val().indexOf("*ALL") != -1){
                    $(element).val(null).trigger("change");
                    $(element).val(e.params.args.data.id);
                    $(element).trigger("change");
                }
            }
        });

        $(element).on("select2:select", function(e){
            $(element).parent().find(".form__label").addClass("populated");
            
            extraOptions.onSelect( e );
        });

        $(element).on("select2:clear", function(e){
            $(element).parent().find(".form__label").removeClass("populated");
            extraOptions.onClear( e );
        });

        if(emptyShowAll){
            $(element).on("select2:unselect", function(e){
                if($(element).val() == ""){
                    $(element).val("*ALL");
                    $(element).trigger("change");
                }
            });
        }
	});
}

export function stopSelect2DefaultOpen(event, selectName){

    var select = "#" + selectName;
    var selectContainer = "." + selectName;

    $(selectContainer + " .select2-search__field").blur();

    if($(event.target).hasClass("select2-selection__choice__remove") || $(event.target).hasClass("select2-selection__choice")){
        return true;
    }
    return false;
}
// TODO translate emptyLabel
export function clearOptions(selector, leaveEmptyOption = false, emptyLabel = "[ Please Select ]") {
    $(selector).empty();
    if ( leaveEmptyOption ){
        var option = new Option( emptyLabel, "", false, false);
        $(selector).append(option);
    }
    $(selector).trigger("change");
}

export function unsetupSelect2(selector) {
    $(selector).each(function(index, element){
        $(element).off("select2:selecting");
        $(element).off("select2:select");
        $(element).off("select2:clear");
        $(element).off("select2:unselect");
        $(element).val(null).trigger("change");

        var selectOptions = {
            allowClear: $(element).attr("data-allow-clear") == "1" ? true : false,
            // placeholder: $(element).attr("data-placeholder"),
            useAjax: $(element).attr("data-type-ahead") == "1" ? true : false,
            maximumSelectionLength: $(element).attr("data-max-selects"),
            url: "",
            ajaxData: {},
            disabled: true,
        };
        $(element).select2(autocompleteOptions(selectOptions, {}));
    });
}

/** 
 * Expects export in the following format:
 *  [
 *      {
 *          "value" => "value",
 *          "label" => "label",
 *          "disabled" => "disabled",
 *          "selected" => "selected",
 *          "attributes" => "attributes"
 *      },
 *      {
 *          "value" => "value",
 *          "label" => "label",
 *          "disabled" => "disabled",
 *          "selected" => "selected",
 *          "attributes" => "attributes"
 *      }
 *  ]
 * Use the 'ExportForLaminasFormOption on the Dropdown class.
 * 
 */
export function setSelect2DropdownOptions(selector, data, triggerChange = true ) {
    $(selector).empty();    
    $.each(data, function( index, optionData ) {
        var selected = false;
        if ( typeof optionData.selected !== "undefined" ){
            selected = optionData.selected;
        }
        
        var option = new Option(optionData.label, optionData.value, selected, selected );
        $(selector).append(option);
    });
    if ( triggerChange ){
        $(selector).trigger("change");
    }    
}
